export default "* Kronhjort\n* Veksel\n* Sølehul\n* Brunst\n";